import main from '@/views/main/router';
import system from '@/views/system/router';
import contractTemplate from '@/views/contractTemplate/router';
import hadoop from '@/views/hadoop/router';
import personal from '@/views/personal/router';
import specialColumn from '@/views/specialColumn/router';
import materialPriceInquiry from '@/views/materialPriceInquiry/router';
import learningCommunity from '@/views/learningCommunity/router';
import note from '@/views/note/router';
import supplier from '@/views/supplier/router';
import topic from '@/views/topic/router';
import activity from '@/views/activity/router';
import musicLibrary from '@/views/musicLibrary/router';

let router = [];
router = router
    .concat(main)
    .concat(system)
    .concat(contractTemplate)
    .concat(hadoop)
    .concat(personal)
    .concat(materialPriceInquiry)
    .concat(supplier)
    .concat(specialColumn)
    .concat(learningCommunity)
    .concat(note)
    .concat(topic)
    .concat(activity)
    .concat(musicLibrary);
export default router;
